"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidSerialNumber = exports.AlarmRows = exports.CatalogResult = exports.SerialBody = exports.CellTowerPatch = exports.AddressPatch = exports.ConsumablePatch = exports.CatalogQuery = exports.SerialQuery = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const openapi_1 = require("../../../../../openapi");
const Consumable = __importStar(require("../../device/consumable/schema"));
const Location = __importStar(require("../../device/location/schema"));
const Log = __importStar(require("../../device/log/schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Admin.Device.Schema';
const serialNumber = effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
    description: 'Device serial number. Used only when the query has no serialNumber key. A query value, including an empty one, wins. The handler does not validate it: a missing device is not 422.',
});
/** Query `serialNumber`. Optional because a missing value is not a validation error. */
exports.SerialQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.SerialQuery`,
});
/**
 * Catalog query. An absent `legacyOutput`, an empty string, or the string `false` selects the v2
 * catalogue. Any other value, including `true` and `1`, selects the legacy catalog.
 */
exports.CatalogQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    legacyOutput: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CatalogQuery`,
    description: 'An absent legacyOutput, an empty string, or the string false selects the v2 catalogue. Any other value selects the legacy catalog.',
});
/**
 * Consumable patch as the admin route forwards it.
 * `serialNumber` is removed before decode. An `items` field replaces the body with that value.
 */
exports.ConsumablePatch = effect_1.Schema.Union(Consumable.PatchBody, effect_1.Schema.Struct({
    serialNumber,
    items: Consumable.PatchBody,
}), effect_1.Schema.extend(Consumable.PatchInstruction, effect_1.Schema.Struct({ serialNumber }))).annotations({
    identifier: `${exports.NAMESPACE}.ConsumablePatch`,
    description: 'One slot instruction, an array of them, or either of those under items. serialNumber may travel with the body and is removed before the instruction is decoded.',
});
/** Installation address plus the serial the admin route uses to choose the device. */
exports.AddressPatch = effect_1.Schema.extend(Location.Address, effect_1.Schema.Struct({ serialNumber })).annotations({
    identifier: `${exports.NAMESPACE}.AddressPatch`,
});
/** Cell-tower request plus the serial the admin route uses to choose the device. */
exports.CellTowerPatch = effect_1.Schema.extend(Location.CellTowerRequest, effect_1.Schema.Struct({ serialNumber })).annotations({
    identifier: `${exports.NAMESPACE}.CellTowerPatch`,
});
/** Body of factory reset. Empty when `serialNumber` is in the query. */
exports.SerialBody = exports.SerialQuery.annotations({
    identifier: `${exports.NAMESPACE}.SerialBody`,
});
/**
 * Either catalog the admin route can return.
 * The v2 catalogue is the default. The legacy catalog is the `legacyOutput` path.
 */
exports.CatalogResult = effect_1.Schema.Union(Consumable.Catalogue, Consumable.Catalog).annotations({
    identifier: `${exports.NAMESPACE}.CatalogResult`,
    description: 'Consumable catalog. The v2 catalogue for the device model, or the legacy catalog when legacyOutput is set.',
});
/**
 * Alarm rows after the admin route discards the page wrapper.
 * The log handler returns `{ items: page }`. This route sets `items` to `page.items`.
 */
exports.AlarmRows = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(Log.Alarm),
}).annotations({
    identifier: `${exports.NAMESPACE}.AlarmRows`,
    description: 'Recent alarms. items is the row array. The page fields itemsCount, pagesCount and page are dropped.',
});
/** 422: the serial number is new and encodes no known model. */
exports.InvalidSerialNumber = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidSerialNumber`, 'INVALID_SERIAL_NUMBER', 'Invalid Serial Number', 'The serial number does not belong to a registered device and encodes no known model. Carries no express-validator field errors.');
//# sourceMappingURL=schema.js.map